import { Delete } from '@mui/icons-material'
import { IconButton, TableCell, TableRow } from '@mui/material'
import { ReactElement, useMemo } from 'react'
import { AddGroupPart } from 'src/store/lists/interfaces'
import { defaultTheme } from 'src/theme'
import CustomField from 'src/ui-components/forms/formik/InputField'
import styled from 'styled-components'
import { Field, mapToField } from './Utils'

interface Item extends AddGroupPart {
  id: number // The index from the arrayHelpers
}

interface Props {
  item: Item
  remove: (id: number) => void
}

const isTouched = (item) =>
  !!item.partNumber || item.stockQty !== 1 || !!item.comment

const mapToFields = (item: AddGroupPart): Field[] => {
  return Object.keys(item)
    ?.filter((i) => i != 'id')
    ?.map((key) => mapToField(key))
}

const Row = (props: Props): ReactElement => {
  const { item, remove } = props
  const isRowTouched = useMemo(() => isTouched(item), [item])
  const fields = useMemo(() => mapToFields(item), [item])

  const handleRemoveItem = (): void => {
    remove(item.id)
  }

  return (
    <StyledTableRow>
      {fields.map((field) => (
        <StyledTableCell key={`cell_${field.name}`}>
          <CustomField
            {...field}
            name={`items[${item.id}].${field.name}`}
            validate={isRowTouched ? field.validate : undefined}
            inputStyle={field.style}
            wrapperStyle={{ margin: '0px' }}
          />
        </StyledTableCell>
      ))}
      <StyledTableCell>
        <IconButton onClick={handleRemoveItem}>
          <StyledDeleteIcon />
        </IconButton>
      </StyledTableCell>
    </StyledTableRow>
  )
}

const StyledTableRow = styled(TableRow)`
  width: 100%;
  vertical-align: top;
  border-bottom: 1px solid ${defaultTheme.colors.border};
  max-height: 92px;
`

const StyledTableCell = styled(TableCell)`
  font-weight: 600;
  font-size: 14px;
  color: ${defaultTheme.colors.columnBorder};
  border-bottom: none;
`

const StyledDeleteIcon = styled(Delete)`
  color: ${defaultTheme.colors.columnBorder};
`

export default Row
